<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: jml
 * @Date: 2019-03-15 10:04:20
 * @LastEditTime: 2020-10-22 15:29:37
 -->
<!--用户管理-->
<template>
  <div class="table-box">
    <!--查询-->
    <searchbar :searchEvent="searchEvent.bind(this)" :parent="this" />
    <!--列表-->
    <div>
      <el-table
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column type="index" label="序号" align="center" width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" align="center" prop="fullName" label="客户姓名"></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="hospitalName"
          label="医院"
        ></el-table-column>
        <!--        <el-table-column :show-overflow-tooltip="true" align="center" prop="departmentName" label="科室">-->
        <!--        </el-table-column>-->
        <!--        <el-table-column :show-overflow-tooltip="true" align="center" prop="dutyName" label="职称"></el-table-column>-->
        <el-table-column :show-overflow-tooltip="true" align="center" prop="startDt" label="拜访时间"></el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="visitMinute"
          label="拜访时长(分钟)"
        ></el-table-column>-->
        <el-table-column
          v-if="!authType || authType == 0"
          :show-overflow-tooltip="true"
          align="center"
          prop="visitAddress"
          label="拜访地址"
        ></el-table-column>
        <el-table-column
          v-if="authType === 1 || authType == 0"
          :show-overflow-tooltip="true"
          align="center"
          label="拜访地点"
          prop="addressPicUrl"
        >
          <template slot-scope="scope">
            <img
              class="table-pic"
              v-if="scope.row.addressPicUrl"
              @click="clickPic(scope,null,false)"
              :src="scope.row.addressPicUrl"
              alt
            />
            <p v-else>-</p>
          </template>
        </el-table-column>
        <el-table-column
          v-if="authType !== 0 && authType !== 1"
          :show-overflow-tooltip="true"
          align="center"
          label="拜访地点"
          prop="addressWatermarkPicUrl"
        >
          <template slot-scope="scope">
            <img
              class="table-pic"
              @click="clickPic(scope,null,false)"
              :src="scope.row.addressWatermarkPicUrl"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="authType === 1"
          :show-overflow-tooltip="true"
          align="center"
          label="客户签名"
          prop="autographPicUrl"
        >
          <template slot-scope="scope">
            <img
              class="table-pic"
              @click="clickPic(scope,null,false)"
              :src="scope.row.autographPicUrl"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="authType !== 0 && authType !== 1"
          :show-overflow-tooltip="true"
          align="center"
          label="现场照片"
          prop="pics"
        >
          <template slot-scope="scope">
            <div v-if="showHr(scope.row.pics,0)">-</div>
            <img
              v-else
              class="table-pic"
              @click="clickPic(scope,0)"
              :src="(scope.row.pics||[])[0]"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="authType !==0 && authType !== 1"
          :show-overflow-tooltip="true"
          align="center"
          label="现场照片"
          prop="pics"
        >
          <template slot-scope="scope">
            <div v-if="showHr(scope.row.pics,1)">-</div>
            <img
              v-else
              class="table-pic"
              @click="clickPic(scope,1)"
              :src="(scope.row.pics||[])[1]"
              alt
            />
          </template>
        </el-table-column>
        <el-table-column
          v-if="authType !== 0 && authType !== 1"
          :show-overflow-tooltip="true"
          align="center"
          label="现场照片"
          prop="pics"
        >
          <template slot-scope="scope">
            <div v-if="showHr(scope.row.pics,2)">-</div>
            <img
              v-else
              class="table-pic"
              @click="clickPic(scope,2)"
              :src="(scope.row.pics||[])[2]"
              alt
            />
          </template>
        </el-table-column>
        <!--        <el-table-column :show-overflow-tooltip="true" align="center" prop="visitAddress" label="拜访地址">-->
        <!--        </el-table-column>-->
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="check(scope.row)">详情</el-button>
             <el-button :disabled="scope.row.auditGongyeStatus !== 1" type="text" size="small" @click="approve(2,scope.row)">通过</el-button>
            <rejectComponent :disabled="scope.row.auditGongyeStatus !== 1" @withdraw="(item)=>approve(3,scope.row,0,item)"/>
          </template>
        </el-table-column>
      </el-table>
      <!--分页-->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paginationData.pageNum"
        :total="totalElements"
        :page-size="paginationData.pageSize"
        layout="total, prev, pager, next, jumper"
        style="padding:15px"
      ></el-pagination>
    </div>
    <el-dialog class="table-dialog" title="提示" :visible.sync="dialogVisible" width="60%">
      <div slot="title"></div>
      <el-carousel
        v-if="dialogVisible"
        :arrow="showArrow?'hover':'never'"
        trigger="click"
        :autoplay="false"
        :initial-index="carouselIndex"
        height="65vh"
      >
        <el-carousel-item v-for="item in imagesList" :key="item">
          <!--          <div style="height: 100%">-->
          <img class="show-modal-ca" :src="item||'#'" alt />
          <!--          </div>-->
        </el-carousel-item>
      </el-carousel>
      <span slot="footer" class="dialog-footer"></span>
    </el-dialog>
  </div>
</template>

<script>
// import datePicker from "@/Mixin/datePicker";
import { project,receive } from "@/api/ajax";
import { pageInation } from "@/Mixin/listMixin";
import { initSearch } from "@/Mixin/initSearch";
import { makeSure } from "@/Mixin/makeSure";
import dicSelect from "@/components/Common/dicSelect.vue";
import OpenNewWin from '@/tools/openNewWin';
import approvalFlagMixins  from '@/Mixin/approvalFlagMixins';

export default {
  mixins: [pageInation, makeSure,approvalFlagMixins],
  data() {
    return {
      showArrow: true,
      carouselIndex: 0,
      dialogVisible: false,
      imagesList: [],
      authType: 0,
      ruleForm: {}, // 用户信息
      getList: project.visitPlanList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskMonth: this.$route.query.month,
        statementId:this.$route.query.statementId
      },
      prop: {
        label: "projectName",
        code: "id"
      },
      searchAjax: project.crmProjectList,
      extraObj: {
        type: 1
      }
    };
  },
  components: {
    dicSelect
  },
  computed: {
    showHr(imgArr, index) {
      return (imgArr, index) => {
        return !imgArr || !imgArr[index] || imgArr[index] == "null";
      };
    }
  },
  methods: {
    check(row) {
      let { id } = this.$route.query;
      this.$router.push({
        name: "recordAcademylDetail",
        query: {
          authType: this.authType,
          detailId: row.id,
          id,
          visitTime: row.startDt
        }
      });
    },
    clickPic(scope, index, arrow) {
      let { row, column } = scope;
      let property = column.property || "";
      let target = row[property];
      if (!Array.isArray(target)) {
        target = [target];
      }
      let curr = index;
      this.imagesList = target.filter((res, idx) => {
        if (!res || res === "null") {
          if (idx < curr) {
            curr--;
          }
        }
        return res && res !== "null";
      });
      this.dialogVisible = true;
      this.showArrow = this.imagesList.length > 1;
      this.carouselIndex = curr || 0;
    },
    dateChange(val) {},
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskMonth) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(project.exporXsbftData + "?" + queryString);
      } else {
        this.$message.error("请选择条件");
      }
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.id;
    },
    add() {
      this.$router.push({
        name: "salerAdd"
      });
    },
    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        visit
          .pass({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: "成功",
              message: "操作成功",
              type: "success"
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },
  filters: {},
  mounted() {
    this.authType = +(localStorage.getItem("authType") || 0);
    // console.log(this.authType,21222)
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
.table-dialog {
  .el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      /*max-height: 600px;*/
      height: inherit;
    }
  }
}

.table-pic {
  object-fit: contain !important;
}

.show-modal-ca {
  /*width: 100%!important;*/
  height: 100% !important;
  object-fit: contain !important;
}
</style>
